export default __webpack_public_path__ + "static/media/ArrowMinRight.1a2d3232.svg";